export enum GroupSize {
  Full = 'full',
  Half = 'half'
}
